import {
  TextInput as CarbonTextInput,
  Checkbox as CarbonCheckbox,
  ComboBox as CarbonCombobox,
  RadioButton as CarbonRadioButton,
  SkeletonPlaceholder as CarbonSkeletonPlaceholder,
  Toggle as CarbonToggle,
  ToggleSmall as CarbonToggleSmall
} from 'carbon-components-react';

export interface TextInput extends CarbonTextInput {};
export interface Checkbox extends CarbonCheckbox {};
export interface ComboBox extends CarbonCombobox {};
export interface RadioButton extends CarbonRadioButton {};
export interface SkeletonPlaceholder extends CarbonSkeletonPlaceholder {};
export interface Toggle extends CarbonToggle {};
export interface ToggleSmall extends CarbonToggleSmall {};

export const TextInput = CarbonTextInput;
export const Checkbox = CarbonCheckbox;
export const ComboBox = CarbonCombobox;
export const RadioButton = CarbonRadioButton;
export const SkeletonPlaceholder = CarbonSkeletonPlaceholder;
export const Toggle = CarbonToggle;
export const ToggleSmall = CarbonToggleSmall;